var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"filter":"invert(100%)"},attrs:{"src":require("@/assets/ic_permissions.png")}})
}
var staticRenderFns = []

export { render, staticRenderFns }